import React, { useState } from 'react';
import ModelConfigTab from './ModelConfigTab';

/**
 * Full-screen (xl) modal wrapper for the global financial model config editor.
 *
 * Props:
 *   onClose()  — called when the user dismisses the modal
 */
export default function ModelConfigModal({ onClose, focus }) {
  const [definitionId, setDefinitionId] = useState(focus?.definitionId || 'default');

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1055 }} onClick={onClose} />
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        style={{ zIndex: 1060, overflowY: 'auto' }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
          style={{ maxWidth: '95vw', width: '95vw' }}
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header bg-dark text-white">
              <h5 className="modal-title">
                <i className="bi bi-sliders me-2" />
                Spreadsheet Model Config
              </h5>
              <span
                className="text-white-50 ms-3"
                style={{ fontSize: 12, fontWeight: 400 }}
              >
                Global — applies to all companies
              </span>
              <button
                type="button"
                className="btn-close btn-close-white ms-auto"
                onClick={onClose}
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-3">
              <ModelConfigTab
                focus={focus}
                definitionId={definitionId}
                onChangeDefinition={setDefinitionId}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
